import { ISession } from '@utils';

const COUPONSINFO = 'COUPONS_INFO';
const COUPONSRECOMMEND = 'COUPONS_RECOMMEND';
const MEMBERSHIPCOUPONINFO = 'MEMBERSHIP_COUPONS_INFO';

export function getCoupons() {
  return ISession(COUPONSINFO) || null;
}

export function setCoupons(info) {
  return ISession(COUPONSINFO, info);
}

export function removeCoupons() {
  removeMembershipCoupons();
  return sessionStorage.removeItem(COUPONSINFO);
}

export function getCouponsRecommend() {
  let r = ISession(COUPONSRECOMMEND) || null;
  try {
    r = JSON.parse(r);
  } catch (error) {
  }
  return r;
}
export function setCouponsRecommend(data = {}) {
  if (typeof data === 'object') {
    data = JSON.stringify(data);
  }
  return ISession(COUPONSRECOMMEND, data);
}

// @aigc:start 2024/06/24-16:25
// 去除COUPONSRECOMMEND
export function removeCouponsRecommend() {
  return sessionStorage.removeItem(COUPONSRECOMMEND);
}
// @aigc:end 2024/06/24-16:25


// 获取会员券信息
// @aigc:start 2024/02/21-14:22
export function getMembershipCoupons() {
  let r = ISession(MEMBERSHIPCOUPONINFO) || null;
  try {
    r = JSON.parse(r);
  } catch (error) {
  }
  return r;
}
// @aigc:end 2024/02/21-14:22

// 设置会员券信息
// @aigc:start 2024/02/21-14:22
export function setMembershipCoupons(info) {
  return ISession(MEMBERSHIPCOUPONINFO, info);
}
// @aigc:end 2024/02/21-14:22

// @aigc:start 2024/02/21-14:23
// 删除会员券信息
export function removeMembershipCoupons() {
  return sessionStorage.removeItem(MEMBERSHIPCOUPONINFO);
}
// @aigc:end 2024/02/21-14:23
